import splide, { customSplide } from "../utils/splide";

const banner = document.getElementById("banner");
if (banner) {
    const bannerSplide = customSplide(banner, {
        type: "fade",
        rewind: true,
        perPage: 1,
        // autoplay: true,
        fixedHeight: "560px",
        speed: 2000,
        lazyLoad: "sequential",
        pagination: false,
        arrows: true,
        breakpoints: {
            1200: {
                pagination: true,
                arrows: false,
                fixedHeight: "228px",
            },
            600: {
              fixedHeight: "unset",
              arrows: false,
              pagination: true,
            },
        },
    });
    bannerSplide.mount();
}

const course = document.getElementById("courses");
if (course) {
    const courseSplide = splide(course, {
        type: 'slide',
        perPage: 3,
        arrows: true,
        gap: "24px",
        breakpoints: {
            1200: {
                perPage: 2,
                pagination: true,
                arrows: false,
            },
            600: {
                perPage: 1,
                pagination: true,
                arrows: false,
            },
        },
    });
    courseSplide.mount();
}
